<template>
  <div>
    <span class="component-label">{{'&lt;'+ $options.name + ' />'}}</span>
    <div class="page-content">
      Profile page content
      <button class="button is-primary is-large">I'm a large Bulma button</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProfileSettingsPage'
}
</script>



// WEBPACK FOOTER //
// src/pages/account/ProfileSettingsPage.vue